export default __webpack_public_path__ + "512e79830cf0bfa9d7bd2c89e9a9491b.png";